import React, { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Button from '@material-ui/core/Button';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import Checkbox from '@material-ui/core/Checkbox';
import useFetch from '../../CustomHooks/useFetch';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';

export default function CallTheWaiter(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [getCallsHookResponse, getCallsHook] = useFetch();
    const [setCallCompletedHookResponse, setCallCompletedHook] = useFetch();
    const timerId = useRef(null);
    const [doneCalls, setDoneCalls] = useState({});
    const [pendingCalls, setPendingCalls] = useState([]);
    const [translateGui] = useGuiTranslations();

    const removeCall = (callId) => {
        let temp = { ...doneCalls };
        temp[callId] = 1;
        setDoneCalls(temp);

        setCallCompletedHook(
            {
                url: '/admin/messages/' + callId,
                method: 'PUT',
                postData: true,
                addTokenHeader: true,
            }
        )
    }

    const getMessages = () => {
        getCallsHook(
            {
                url: '/admin/messages?MarkAsRead=false',
                method: 'GET',
                postData: null,
                addTokenHeader: true,
            }
        )
    }
    useEffect(
        () => {
            console.log('burada');
            getMessages();
        }, []
    )

    useEffect(
        () => {
            //console.log(getCallsHookResponse);
            if (getCallsHookResponse.messages) {
                setPendingCalls(getCallsHookResponse.messages);
            }
        }, [getCallsHookResponse]
    )

    useEffect(
        () => {
            //console.log(timerId);
            if (getCallsHookResponse.messages == null) {

                if (!timerId.current) {
                    console.log('timer baslar');
                    timerId.current = setInterval(getMessages, 5000);
                }
            }
        }, [getCallsHookResponse]
    )


    useEffect(
        () => {
            return () => { clearInterval(timerId.current) }
        }, []
    )

    return (
        <div className={classes.root}>
            {
                pendingCalls.length > 0 ?
                    <div className={classes.innerWrapper}>
                        <div className={classes.title}>
                            <EmojiPeopleIcon className={classes.customerIcon}></EmojiPeopleIcon>
                            <span className={classes.titleText}>
                                {capitalizeFirstLetter(translateGui(111))}
                    </span>
                        </div>
                        {
                            pendingCalls.map(
                                pendingCall =>
                                    doneCalls[pendingCall.messageId] == undefined ?
                                        <div key={pendingCall.messageId} className={classes.line}>
                                            <div className={classes.flexColumn}>
                                                <span className={classes.tableName}>{capitalizeFirstLetter(translateGui(24))}:{pendingCall.tableNumber}</span>
                                                <span className={classes.request}>{pendingCall.message}</span>
                                            </div>
                                            <Checkbox onClick={() => removeCall(pendingCall.messageId)} color="primary" inputProps={{ 'aria-label': 'secondary checkbox' }} />
                                            <Button style={{ display: 'none' }} className={classes.button} onClick={() => removeCall(pendingCall.messageId)} variant="contained" color="primary">DONE</Button>
                                        </div>
                                        : null

                            )
                        }
                    </div>
                    : null
            }
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    innerWrapper: {
        width: '95%',
        margin: 'auto',
        padding: '20px 0',
        border: '1px solid #c5c5c5',
        marginBottom: '20px',
        boxShadow: '5px 5px 5px 0px rgba(0, 0, 0, 0.25)',
        backgroundColor: 'white',
        borderRadius: '10px',
    },
    tableName: {
        fontSize: '0.9rem',
        color: '#4c4c4c',
        fontWeight: 700,
    },
    line: {
        borderBottom: '1px solid #d0cbcb',
        //marginBottom: '10px',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '10px',
        //backgroundColor: '#f7f7f7',
        padding: '10px 10px',

        '@media (min-width : 600px)': {
            justifyContent: 'space-between',
            flexDirection: 'row',
        }


    },
    button: {
        width: '100px',
        alignSelf: 'center',
    },
    request: {
        //margin: '10px 0',
        paddingTop: '5px',
        fontSize: '0.8rem',
    },
    customerIcon: {
        color: '#f84709',
        fontSize: '1.7rem',
    },
    title: {
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 10px',
    },
    titleText: {
        fontSize: '14px',
        fontWeight: '700',
        color: '#4c4c4c',
        marginLeft: '9px',
    }
});